import produce from 'immer';
import { EErrorActions, ErrorActions } from '@app/core/store/error/error.actions';
import { ISettingsState, initialSettingsState } from '@app/core/store/settings/settings.state';
import { SettingsActions, ESettingsActions } from '@app/core/store/settings/settings.actions';

export const settingsReducers = (state: ISettingsState = initialSettingsState, action: SettingsActions | ErrorActions): ISettingsState => {
  let nextState;

  switch (action.type) {
    case ESettingsActions.FetchBookingHours:
      nextState = produce(state, draftState => {
        draftState.isLoading = true;
      });

      return nextState;
    case ESettingsActions.FetchBookingHoursSuccess:
      nextState = produce(state, draftState => {
        draftState.isLoading = false;
        draftState.booking_hours = action.hours;
      });

      return nextState;

    case ESettingsActions.ChangeBookingHours:
      nextState = produce(state, draftState => {
        draftState.isLoading = true;
      });

      return nextState;
    case ESettingsActions.ChangeBookingHoursSuccess:
      nextState = produce(state, draftState => {
        draftState.isLoading = false;
      });

      return nextState;

    // Fetch SMS Settings

    case ESettingsActions.FetchSMSSettings:
      nextState = produce(state, draftState => {
        draftState.isLoading = true;
      });

      return nextState;
    case ESettingsActions.FetchSMSSettingsSuccess:
      nextState = produce(state, draftState => {
        draftState.isLoading = false;
        draftState.smsSettings = action.settings;
      });

      return nextState;

    // Fetch SMS Templates

    case ESettingsActions.FetchSMSTemplates:
      nextState = produce(state, draftState => {
        draftState.isLoading = true;
      });

      return nextState;
    case ESettingsActions.FetchSMSTemplatesSuccess:
      nextState = produce(state, draftState => {
        draftState.isLoading = false;
        draftState.smsTemplates = action.templates;
      });

      return nextState;

    // Update SMS Template

    case ESettingsActions.UpdateSMSTemplate:
      nextState = produce(state, draftState => {
        draftState.isLoading = true;
      });

      return nextState;
    case ESettingsActions.UpdateSMSTemplateSuccess:
      nextState = produce(state, draftState => {
        draftState.isLoading = false;
      });

      return nextState;

    // Set Sidebar Visibility

    case ESettingsActions.SetSidebarVisibility:
      nextState = produce(state, draftState => {
        draftState.isSidebarVisible = action.isVisible;
      });

      return nextState;

    // ERROR

    case EErrorActions.LoadError:
      nextState = produce(state, draftState => {
        draftState.isLoading = false;
      });

      return nextState;
    default:
      return state;
  }
};
